module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Expenses")])], 1), _vm._v(" "), _c('banner-component', {
    attrs: {
      "allModuleIdBanner": this.$sessionsStorage.get('allModuleIdMain') ?
        this.$sessionsStorage.get('allModuleIdMain') :
        '',
      "jobSeriesBanner": this.$sessionsStorage.get('JOBSERIES') ?
        this.$sessionsStorage.get('JOBSERIES') :
        '',
      "bannerClientName": _vm.assignmentData[0].clientName ? _vm.assignmentData[0].clientName : '',
      "iconId": "fa fa-ship"
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [_c('div', [(
    (_vm.INVDetail.exp_id != '' && _vm.accounts == false) ||
    (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
  ) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.INVDetail.revisedMail),
      expression: "INVDetail.revisedMail"
    }],
    attrs: {
      "id": 'revcheckbox',
      "name": "checkbox-1",
      "type": "checkbox",
      "value": "1",
      "unchecked-value": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.INVDetail.revisedMail) ? _vm._i(_vm.INVDetail.revisedMail, "1") > -1 : (_vm.INVDetail.revisedMail)
    },
    on: {
      "click": function($event) {
        _vm.RevisedAss('revcheckbox')
      },
      "change": function($event) {
        var $$a = _vm.INVDetail.revisedMail,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.INVDetail.revisedMail = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.INVDetail.revisedMail = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.INVDetail, "revisedMail", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v("Send Revised Expenses Request")])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('b-row', {
    staticClass: "ml-0 mr-0"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_c('b-badge', {
    staticClass: "ml-2",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Assignment Details")])], 1), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.assignmentData,
      "fields": _vm.assignmentFields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "Job_Series",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.Job_Series != "" ? row1.item.Job_Series : "--"))])]
      }
    }, {
      key: "JobDate",
      fn: function(row2) {
        return [_c('span', [_vm._v(_vm._s(row2.item.JobDate != "" ? row2.item.JobDate : "--"))])]
      }
    }, {
      key: "clientName",
      fn: function(row3) {
        return [_c('span', [_vm._v(_vm._s(row3.item.clientName != "" ? row3.item.clientName : "--"))])]
      }
    }, {
      key: "POD",
      fn: function(row4) {
        return [_c('span', [_vm._v(_vm._s(row4.item.POD != "" ? row4.item.POD : "--"))])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_c('b-badge', {
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("Expense Document Details")])], 1), _vm._v(" "), _c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.ExpenseData,
      "fields": _vm.ExpenseDocumentFields,
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "expenseDate",
      fn: function(row1) {
        return [_c('span', [_vm._v(_vm._s(row1.item.expenseDate != "" ? row1.item.expenseDate : "--"))])]
      }
    }, {
      key: "documentLink",
      fn: function(row2) {
        return [(row2.item.documentLink) ? _c('a', {
          staticStyle: {
            "color": "blue"
          },
          attrs: {
            "href": "javascript:void(0)"
          },
          on: {
            "click": function($event) {
              _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + (_vm.assignmentData[0].Job_Series.replaceAll('/', '_')) + "/" + (row2.item.documentLink.replaceAll('/', '_'))))
            }
          }
        }, [_c('b', [_c('u', [_vm._v("View")])])]) : _vm._e()]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    attrs: {
      "align-v": "start"
    }
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('multi-file-uploader', {
    style: ('height: 80px; background: darkgray; width: 100%'),
    attrs: {
      "documentName": 'Expense_Multiple_Doc-',
      "otherDocName": 'Expense_Multiple_Doc-',
      "folderName": 'Expense',
      "accept": '*',
      "assign_no": _vm.assignmentData[0].Job_Series,
      "multiple": true,
      "state": Boolean(_vm.singleUpload),
      "fileAllModuleId": _vm.$sessionsStorage.get('allModuleIdMain')
    },
    model: {
      value: (_vm.singleUpload),
      callback: function($$v) {
        _vm.singleUpload = $$v
      },
      expression: "singleUpload"
    }
  }), _vm._v(" "), (_vm.files_err ? true : false) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.files_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Nature Of Expense"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    style: ({
      borderColor: (!_vm.nature_of_expense && _vm.nature_of_expense_err) ? 'red' : '',
    }),
    attrs: {
      "list": _vm.natureOfExpenseList,
      "option-value": "label",
      "option-text": "label",
      "placeholder": "Select Nature Of Expense"
    },
    on: {
      "input": function($event) {
        _vm.getNatureOfExpenseTitile()
      }
    },
    model: {
      value: (_vm.nature_of_expense),
      callback: function($$v) {
        _vm.nature_of_expense = $$v
      },
      expression: "nature_of_expense"
    }
  }), _vm._v(" "), (_vm.nature_of_expense_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.nature_of_expense_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Remark "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "DocRemark",
      "id": "DocRemark",
      "rows": "6"
    },
    model: {
      value: (_vm.docRemark),
      callback: function($$v) {
        _vm.docRemark = $$v
      },
      expression: "docRemark"
    }
  }), _vm._v(" "), (_vm.docRemark_err) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.docRemark_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "md": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSB",
      "disabled": _vm.assignmentData[0].Job_Series != _vm.$sessionsStorage.get('JOBSERIES') ||
        _vm.singleUpload == '' ?
        true :
        false
    },
    on: {
      "click": _vm.adddragfilesINVDetail
    }
  }, [_vm._v("Save & Submit\n                ")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderSB"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.lineInvModalArray), function(itm, idx) {
    return _c('b-card', {
      key: idx,
      staticClass: "mt-2"
    }, [(idx != 0) ? _c('div', {
      staticClass: "d-flex align-items-center"
    }, [_c('b-button', {
      staticClass: "ml-auto",
      attrs: {
        "id": "show-btn",
        "size": "sm",
        "variant": "danger"
      },
      on: {
        "click": function($event) {
          _vm.removeInvArry(idx)
        }
      }
    }, [_vm._v("\n                  Remove Expenses "), _c('i', {
      staticClass: "fa fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.INVDetail.revisedMail != 0) ? _c('div', {
      staticClass: "mt-2"
    }, [_c('input', {
      attrs: {
        "disabled": itm.invPayStatus == 2 || itm.invPayStatus == 1 ? true : false,
        "id": 'checkbox-' + idx,
        "type": "checkbox"
      },
      on: {
        "click": function($event) {
          _vm.addRevisedInvoice(idx, 'checkbox-' + idx)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "error"
    }, [_vm._v("Revise Expenses")])]) : _vm._e(), _vm._v(" "), _c('b-row', {
      attrs: {
        "align-v": "start"
      }
    }, [_c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', {
      attrs: {
        "for": "refuelStationId"
      }
    }, [_vm._v("Vendor "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "list": _vm.getVendorData,
        "id": "refuelStationId",
        "isDisabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "option-value": "refuelStationId",
        "option-text": "vendorName",
        "placeholder": "Select Vendor Name"
      },
      on: {
        "input": function($event) {
          _vm.onSelectVendor(idx, itm, itm.vendor)
        }
      },
      model: {
        value: (itm.vendor),
        callback: function($$v) {
          _vm.$set(itm, "vendor", $$v)
        },
        expression: "itm.vendor"
      }
    }), _vm._v(" "), (itm.otherVendorFlag != false) ? _c('b-form-input', {
      staticClass: "mt-2",
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "otherVendor",
        "id": "otherVendor"
      },
      model: {
        value: (itm.otherVendor),
        callback: function($$v) {
          _vm.$set(itm, "otherVendor", $$v)
        },
        expression: "itm.otherVendor"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Type "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "multiple": "true",
        "isDisabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "list": _vm.invoiceTypeList,
        "option-value": "value",
        "option-text": "text",
        "placeholder": "Select Invoice Type"
      },
      model: {
        value: (itm.invType),
        callback: function($$v) {
          _vm.$set(itm, "invType", $$v)
        },
        expression: "itm.invType"
      }
    }), _vm._v(" "), (itm.invType_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invType_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice No "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "InvoiceNo",
        "id": "InvoiceNo"
      },
      model: {
        value: (itm.invNo),
        callback: function($$v) {
          _vm.$set(itm, "invNo", $$v)
        },
        expression: "itm.invNo"
      }
    }), _vm._v(" "), (itm.invNo_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invNo_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Date "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _c('br'), _vm._v(" "), _c('date-picker', {
      attrs: {
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "InvoiceDate",
        "id": "InvoiceDate",
        "minute-step": 1
      },
      on: {
        "input": function($event) {
          _vm.onChooseInvoiceDate($event, itm)
        }
      },
      model: {
        value: (itm.invDate),
        callback: function($$v) {
          _vm.$set(itm, "invDate", $$v)
        },
        expression: "itm.invDate"
      }
    }), _vm._v(" "), (itm.invDate_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invDate_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Invoice Amount "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "type": "number",
        "name": "InvoiceAmount",
        "id": "InvoiceAmount"
      },
      model: {
        value: (itm.invAmount),
        callback: function($$v) {
          _vm.$set(itm, "invAmount", $$v)
        },
        expression: "itm.invAmount"
      }
    }), _vm._v(" "), (itm.invAmount_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invAmount_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Currency "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "isDisabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "list": _vm.currList,
        "option-value": "payVal",
        "option-text": "payText",
        "placeholder": "Select Currency"
      },
      model: {
        value: (itm.invCurrency),
        callback: function($$v) {
          _vm.$set(itm, "invCurrency", $$v)
        },
        expression: "itm.invCurrency"
      }
    }), _vm._v(" "), (itm.invCurrency_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invCurrency_err))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "shippingBillNo",
        "id": "shippingBillNo"
      },
      model: {
        value: (itm.invRemarks),
        callback: function($$v) {
          _vm.$set(itm, "invRemarks", $$v)
        },
        expression: "itm.invRemarks"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "6"
      }
    }, [_c('md-input-container', [_c('label', [_vm._v("Invoice Documents "), _c('span', {
      staticClass: "error"
    }, [_vm._v("*")])]), _vm._v(" "), _c('md-file', {
      attrs: {
        "disabled": _vm.accounts == true && _vm.role != 'Admin' ? true : false,
        "name": "invoiceUpload",
        "id": "invoiceUpload"
      },
      on: {
        "selected": function($event) {
          _vm.onFileChangeBlDraft('Sline_Invoice', idx)
        }
      },
      model: {
        value: (itm.invSlineUpload),
        callback: function($$v) {
          _vm.$set(itm, "invSlineUpload", $$v)
        },
        expression: "itm.invSlineUpload"
      }
    })], 1), _vm._v(" "), (itm.invSlineUpload_err) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invSlineUpload_err))]) : _vm._e(), _vm._v(" "), (_vm.viewInvDoc.length > 0) ? _c('md-layout', {
      staticClass: "gutr",
      attrs: {
        "md-gutter": ""
      }
    }, _vm._l((_vm.viewInvDoc), function(item, index) {
      return _c('md-layout', {
        key: index,
        attrs: {
          "md-flex": "40"
        }
      }, [(_vm.assign_no_series) ? _c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.openSignedDocument(("ASSIGNMENT_UPLOADS/" + _vm.doc_path + "/" + (item.replaceAll('/', '_'))))
          }
        }
      }, [_vm._v("--View Document - " + _vm._s(index + 1))]) : _vm._e()])
    })) : _vm._e()], 1), _vm._v(" "), (
      (_vm.INVDetail.exp_id != '' && _vm.accounts == true) ||
      (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
    ) ? _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Payment Mode")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "isDisabled": _vm.accounts != true && _vm.role != 'Admin' ? true : false,
        "list": _vm.payList,
        "option-value": "payVal",
        "option-text": "payText",
        "placeholder": "Select Payment Mode"
      },
      on: {
        "input": function($event) {
          _vm.onSelectPaymentMode($event, itm)
        }
      },
      model: {
        value: (itm.invPayMode),
        callback: function($$v) {
          _vm.$set(itm, "invPayMode", $$v)
        },
        expression: "itm.invPayMode"
      }
    }), _vm._v(" "), (itm.invPayMode_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invPayMode_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
      (_vm.INVDetail.exp_id != '' && _vm.accounts == true) ||
      (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
    ) ? _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Payment Ref")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "disabled": _vm.accounts != true && _vm.role != 'Admin' ? true : false,
        "formatter": _vm.capitalizeAll,
        "name": "PaymentRef",
        "id": "PaymentRef"
      },
      model: {
        value: (itm.invPayRef),
        callback: function($$v) {
          _vm.$set(itm, "invPayRef", $$v)
        },
        expression: "itm.invPayRef"
      }
    }), _vm._v(" "), (itm.invPayRef_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invPayRef_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
      (_vm.INVDetail.exp_id != '' && _vm.accounts == true) ||
      (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
    ) ? _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Payment Amount")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "disabled": _vm.accounts != true && _vm.role != 'Admin' ? true : false,
        "formatter": _vm.capitalizeAll,
        "name": "PaymentAmount",
        "id": "PaymentAmount"
      },
      model: {
        value: (itm.invPaidAmount),
        callback: function($$v) {
          _vm.$set(itm, "invPaidAmount", $$v)
        },
        expression: "itm.invPaidAmount"
      }
    }), _vm._v(" "), (itm.invPaidAmount_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invPaidAmount_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
      (_vm.INVDetail.exp_id != '' && _vm.accounts == true) ||
      (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
    ) ? _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Payment Date")]), _vm._v(" "), _c('date-picker', {
      attrs: {
        "disabled": _vm.accounts != true && _vm.role != 'Admin' ? true : false,
        "format": _vm.selectDateFormat,
        "lang": "en",
        "name": "PaymentDate",
        "id": "PaymentDate",
        "minute-step": 1
      },
      on: {
        "input": function($event) {
          _vm.onChoosePaymentDate($event, itm)
        }
      },
      model: {
        value: (itm.invPayDate),
        callback: function($$v) {
          _vm.$set(itm, "invPayDate", $$v)
        },
        expression: "itm.invPayDate"
      }
    }), _vm._v(" "), (itm.invPayDate_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invPayDate_err))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (
      (_vm.INVDetail.exp_id != '' && _vm.accounts == true) ||
      (_vm.INVDetail.exp_id != '' && _vm.role == 'Admin')
    ) ? _c('b-col', {
      attrs: {
        "cols": "3"
      }
    }, [_c('label', [_vm._v("Payment Status")]), _vm._v(" "), _c('model-list-select', {
      attrs: {
        "isDisabled": _vm.accounts != true && _vm.role != 'Admin' ? true : false,
        "list": _vm.statusList,
        "option-value": "payVal",
        "option-text": "payText",
        "placeholder": "Select Payment Status"
      },
      on: {
        "input": function($event) {
          _vm.onSelectPaymentStatus($event, itm)
        }
      },
      model: {
        value: (itm.invPayStatus),
        callback: function($$v) {
          _vm.$set(itm, "invPayStatus", $$v)
        },
        expression: "itm.invPayStatus"
      }
    }), _vm._v(" "), (itm.invPayStatus_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(itm.invPayStatus_err))]) : _vm._e()], 1) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [(_vm.lineInvModalArray.length > 0) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoaderSB"
    },
    on: {
      "click": _vm.addINVDetail
    }
  }, [_vm._v("Save & Submit\n                ")]) : _vm._e()], 1)], 1)], 2)])], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "popMailAfter",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48492fd3","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/allModuleForm/Expenses.vue
// module id = 2587
// module chunks = 0